import queryString from 'query-string';

export function getFilterSearchObjFromQueryStr() {
  let searchStrKey = '';
  let searchStrValue = '';
  try {
    const filtersStr = JSON.parse(
      queryString.parse(window.location.search).filters as string
    );

    searchStrKey = Boolean(filtersStr?.['address.country'])
      ? 'address.country'
      : Boolean(filtersStr?.['address.city'])
      ? 'address.city'
      : Boolean(filtersStr?.['address.state'])
      ? 'address.state'
      : 'address.name';

    searchStrValue = filtersStr?.[searchStrKey];
  } catch (e) {}

  return { searchStrKey, searchStrValue };
}

export function getSearchObjectFromAutocomplete(val: any) {
  let field = val?.field;
  let value = val?._id;

  if (typeof val === 'string') {
    field = 'name';
    value = val;
  }

  let searchStrKey = 'address.name';

  if (['city', 'country', 'state', 'neighbor'].includes(field)) {
    searchStrKey = `address.${field}`;
  }

  const searchStrValue = value;

  return { searchStrKey, searchStrValue };
}
